import { HTTP } from '@/http-common';
import { defineStore } from 'pinia';

export const useZakhirStore = defineStore('zakhir', {
    state: () => ({
        plans: [],
        payment: null
    }),
    getters: {
        getZakhirPlans: (state) => state.plans,
        getZakhirPayment: (state) => state.payment
    },
    actions: {
        async fetchZakhirPlans() {
            return new Promise((resolve, reject) => {
                HTTP.get('/zakhir/plans').then((response) => {
                    this.plans = response.data;
                    resolve(response.data);
                }).catch((error) => {
                    console.error('Error fetching Zakhir plans:', error);
                    reject(error);
                });
            });
        },
        async sendZakhirOtp(phoneNumber) {
            const response = await HTTP.post('/zakhir/otp/send', { phoneNumber });
            return response.data;
        },
        async verifyZakhirOtp(userId, phoneNumber, planUuid, otp, loggedIn = true) {
            const response = await HTTP.post('/zakhir/otp/verify', {
                user_id: userId,
                phoneNumber,
                plan_uuid: planUuid,
                otp,
                logged_in: loggedIn
            });
            this.payment = response.data;
            return response.data;
        },
        /**
         * Poll Zakhir payment status
         * @param id
         * @return {Promise<object>} - the payment status object
         */
        async getZakhirPaymentStatus(id) {
            return new Promise((resolve, reject) => {
                HTTP.get(`/zakhir/${id}`).then((response) => {
                    this.payment = response.data;
                    resolve(response.data);
                }).catch((error) => {
                    console.error('Error fetching Zakhir payment status:', error);
                    reject(error);
                });
            });
        }
,   

        /**
         * Cancel Zakhir subscription
         * @param userId
         * @return {Promise<object>} - the cancellation response object
         */      
        async cancelZakhirSubscription(userId) {
            const response = await HTTP.post('/zakhir/subscriptions/cancel', { user_id: userId });
            return response.data;
        }
    }
});
